var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 4.33321L11.666 6.99988M2.66602 13.3332H5.33268L12.3327 6.33321C12.6863 5.97959 12.885 5.49997 12.885 4.99988C12.885 4.49978 12.6863 4.02016 12.3327 3.66654C11.9791 3.31292 11.4994 3.11426 10.9993 3.11426C10.4993 3.11426 10.0196 3.31292 9.66602 3.66654L2.66602 10.6665V13.3332Z",
    stroke: "#333336",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a689e6f4e97556bf293a8bac9ad37c26.svg";
export { ForwardRef as ReactComponent };